export default __webpack_public_path__ + "static/media/kitchen5-afterA-2048w.d6a68811.png";